import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../assets/GuideWell_Blue.png';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="gw-footer">
      <div className="gw-footer-container">

        {/* Brand */}
        <div className="gw-footer-brand">
          <div className="gw-footer-top-row">
            <h2 className="gw-footer-dtecx">DTecX</h2>
            <div className="gw-footer-divider" />
            <img src={logo} alt="GuideWell" className="gw-footer-logo" />
          </div>
          <p className="gw-footer-desc">
            GuideWell is the all-in-one property management platform by DTecX.
            Track portfolios, monitor financials, and stay ahead of every deadline.
          </p>
        </div>

        {/* Legal links */}
        <div className="gw-footer-col">
          <h4 className="gw-footer-col-title">Legal</h4>
          <ul className="gw-footer-links">
            <li>
              <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
            </li>
            <li>
              <RouterLink to="/terms-of-service">Terms of Service</RouterLink>
            </li>
          </ul>
        </div>

      </div>

      <div className="gw-footer-bottom">
        <span>© {new Date().getFullYear()} DTecX. All rights reserved.</span>
        <span className="gw-footer-powered">Powered by GuideWell</span>
      </div>
    </footer>
  );
};

export default Footer;
